module.exports = __webpack_public_path__ + "img/bg7.ef970de7.jpg";